import React from "react";

const borderGradientId = "operatorAiIndicator_border_linear";
const sparkleSmallGradientId = "operatorAiIndicator_sparkleSmall_linear";
const sparkleLargeGradientId = "operatorAiIndicator_sparkleLarge_linear";

/**
 * "AI" pill indicator used to mark Operator-supported options. Renders a peach
 * pill with a gradient border, two sparkle glyphs, and the "AI" wordmark.
 */
export const OperatorAiIndicator = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
  return (
    <svg
      width="38"
      height="20"
      viewBox="0 0 38 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="AI"
      {...props}
    >
      <rect x="0.5" y="0.5" width="36.1786" height="19" rx="3.5" fill="#FFF4EE" />
      <rect x="0.5" y="0.5" width="36.1786" height="19" rx="3.5" stroke={`url(#${borderGradientId})`} />
      <path
        opacity="0.9"
        d="M6.84766 11.4945C6.9824 11.234 7.04977 11.1038 7.12425 11.0402C7.31124 10.8806 7.58653 10.8806 7.77352 11.0402C7.848 11.1038 7.91537 11.234 8.05011 11.4945C8.25358 11.8879 8.35532 12.0846 8.49124 12.255C8.61184 12.4063 8.75211 12.5419 8.90857 12.6585C9.08489 12.7898 9.28837 12.8882 9.69532 13.0849C9.92539 13.1961 10.0404 13.2517 10.0991 13.3093C10.2987 13.5053 10.2987 13.8268 10.0991 14.0228C10.0404 14.0804 9.92539 14.136 9.69532 14.2472C9.28837 14.4439 9.08489 14.5423 8.90857 14.6737C8.75211 14.7903 8.61184 14.9258 8.49124 15.0771C8.35532 15.2475 8.25358 15.4442 8.05011 15.8376C7.91537 16.0981 7.848 16.2284 7.77352 16.2919C7.58653 16.4516 7.31124 16.4516 7.12425 16.2919C7.04977 16.2284 6.9824 16.0981 6.84766 15.8376C6.64419 15.4442 6.54245 15.2475 6.40653 15.0771C6.28593 14.9258 6.14566 14.7903 5.9892 14.6737C5.81288 14.5423 5.6094 14.4439 5.20245 14.2472C4.97238 14.136 4.85734 14.0804 4.79865 14.0228C4.59909 13.8268 4.59909 13.5053 4.79865 13.3093C4.85734 13.2517 4.97238 13.1961 5.20245 13.0849C5.6094 12.8882 5.81288 12.7898 5.9892 12.6585C6.14566 12.5419 6.28593 12.4063 6.40653 12.255C6.54245 12.0846 6.64419 11.8879 6.84766 11.4945Z"
        fill={`url(#${sparkleSmallGradientId})`}
      />
      <path
        opacity="0.9"
        d="M12.0706 4.86822C12.3025 4.28542 12.4184 3.99402 12.5844 3.90826C12.7284 3.83389 12.8994 3.83389 13.0434 3.90826C13.2094 3.99402 13.3253 4.28542 13.5572 4.86822L13.7172 5.27033C13.9334 5.81356 14.0414 6.08518 14.2095 6.31364C14.3584 6.51613 14.5415 6.69305 14.7509 6.83703C14.9873 6.99948 15.2682 7.10395 15.8302 7.31288L16.162 7.43624C16.7854 7.66801 17.0971 7.7839 17.1862 7.95257C17.2634 8.09868 17.2634 8.27349 17.1862 8.41961C17.0971 8.58827 16.7854 8.70416 16.162 8.93594L15.8302 9.05929C15.2683 9.26823 14.9873 9.37269 14.7509 9.53515C14.5415 9.67913 14.3584 9.85604 14.2095 10.0585C14.0414 10.287 13.9334 10.5586 13.7172 11.1018L13.5572 11.504C13.3253 12.0868 13.2094 12.3782 13.0434 12.4639C12.8994 12.5383 12.7284 12.5383 12.5844 12.4639C12.4184 12.3782 12.3025 12.0868 12.0706 11.504L11.9106 11.1018C11.6945 10.5586 11.5864 10.287 11.4183 10.0585C11.2694 9.85604 11.0864 9.67913 10.8769 9.53515C10.6405 9.37269 10.3596 9.26823 9.7976 9.05929L9.46582 8.93594C8.84242 8.70416 8.53071 8.58827 8.44163 8.41961C8.36445 8.27349 8.36445 8.09868 8.44163 7.95257C8.53071 7.7839 8.84242 7.66801 9.46582 7.43624L9.7976 7.31288C10.3596 7.10395 10.6405 6.99948 10.8769 6.83703C11.0864 6.69305 11.2694 6.51613 11.4183 6.31364C11.5864 6.08518 11.6945 5.81356 11.9106 5.27033L12.0706 4.86822Z"
        fill={`url(#${sparkleLargeGradientId})`}
      />
      <path
        d="M22.1587 14H20.3467L23.4547 5.6H25.4587L28.5787 14H26.6467L26.1067 12.452H22.7107L22.1587 14ZM23.2147 10.976H25.5907L24.4027 7.592L23.2147 10.976ZM29.7294 5.6H31.5414V14H29.7294V5.6Z"
        fill="#9F2514"
      />
      <defs>
        <linearGradient
          id={borderGradientId}
          x1="-0.00635094"
          y1="17.3822"
          x2="29.7043"
          y2="-12.1001"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#801ED7" />
          <stop offset="0.5" stopColor="#E9371F" />
          <stop offset="0.8" stopColor="#FFA524" />
        </linearGradient>
        <linearGradient
          id={sparkleSmallGradientId}
          x1="3.99882"
          y1="16.1272"
          x2="12.3824"
          y2="11.4977"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#801ED7" />
          <stop offset="0.5" stopColor="#E9371F" />
          <stop offset="0.8" stopColor="#FFA524" />
        </linearGradient>
        <linearGradient
          id={sparkleLargeGradientId}
          x1="7.44714"
          y1="12.0146"
          x2="20.4882"
          y2="4.81306"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#801ED7" />
          <stop offset="0.5" stopColor="#E9371F" />
          <stop offset="0.8" stopColor="#FFA524" />
        </linearGradient>
      </defs>
    </svg>
  );
};
